import { Button } from "@volca/ui/components/ui/button";
import { RETURN_AIR_GRILLE } from "@volca/ui/components/ui/empty-machine";
import { MachineEmptyState } from "@volca/ui/components/ui/machine-empty-state";

export const ReferralsFilterEmptyState = ({
  onClear,
}: {
  onClear: () => void;
}) => (
  <MachineEmptyState
    art={RETURN_AIR_GRILLE}
    title="No referrals match your search and filters"
    description="Try a different search or widen the date range."
  >
    <Button variant="outline" size="sm" onClick={onClear}>
      Clear search and filters
    </Button>
  </MachineEmptyState>
);
